export default "../../src/img/lysiq-logo-simplified-4.svg";